import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { IonItem, IonIcon, IonProgressBar, IonButton } from "@ionic/react";
import { closeOutline, checkmarkOutline } from "ionicons/icons";
import prettyBytes from "pretty-bytes";
import styled from "styled-components";

import { FileUploadStatus } from "../../modules";

export const FileTypes = {
  IMAGE: {},
  ANY: {},
};

const getColor = (props) => {
  if (props.isDragAccept) {
    return "#00e676";
  }
  if (props.isDragReject) {
    return "#ff1744";
  }
  if (props.isDragActive) {
    return "#2196f3";
  }
  return "#eeeeee";
};

const DropContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${(props) => getColor(props)};
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
`;

const SelectedContainer = styled.div``;
const SelectedItem = styled(IonItem)`
  border-color: #eeeeee;
  background-color: #fafafa;
  margin: 8px;
`;
const FileInfo = styled.div``;
const FileName = styled.div`
  color: #15c;
  font-weight: bold;
  font-size: 0.9em;
  margin-right: 4px;
`;
const FileSize = styled.div`
  font-size: 0.9em;
  color: #777;
`;
const FileCancel = styled(IonIcon)``;
const ProgressBar = styled(IonProgressBar)`
  margin-top: 4px;
`;
const SubmitButton = styled(IonButton)`
  width: 100%;

  box-sizing: border-box;

  margin-right: 4px;
`;
const SuccessIcon = styled(IonIcon)`
  color: #29c467;
  margin-right: 4px;
`;

const ErrorIcon = styled(IonIcon)`
  color: red;
  margin-right: 4px;
`;

const FileSelector = (props) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);

  const handleFileSelected = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setSelectedFiles(acceptedFiles);
    }
  };

  const handleRemoveFile = (removeIndex) => {
    const newSelectedFiles = [];
    selectedFiles.forEach((file, index) => {
      if (index !== removeIndex) {
        newSelectedFiles.push(file);
      }
    });

    setSelectedFiles(newSelectedFiles);
  };

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({ onDrop: handleFileSelected });
  // } = useDropzone({ onDrop: handleFileSelected, accept: "image/*" });

  const dropZoneComponent = (
    <DropContainer
      {...getRootProps({ isDragActive, isDragAccept, isDragReject })}
    >
      <input {...getInputProps()} />
      <p>Drag 'n' drop some files here, or click to select files</p>
    </DropContainer>
  );

  const selectedItems = selectedFiles.map((file, index) => {
    let progressBar = null;
    let statusIcon = null;
    let cancelButton = (
      <FileCancel
        icon={closeOutline}
        slot="end"
        onClick={() => handleRemoveFile(index)}
      />
    );

    if (props.uploadFilesProgress && props.uploadFilesProgress.length > index) {
      progressBar =
        props.uploadFilesProgress[index].status === FileUploadStatus.ONGOING ? (
          <ProgressBar value={props.uploadFilesProgress[index].progress} />
        ) : null;

      cancelButton = null;

      if (
        props.uploadFilesProgress[index].status === FileUploadStatus.SUCCESS
      ) {
        statusIcon = <SuccessIcon icon={checkmarkOutline} />;
      } else if (
        props.uploadFilesProgress[index].status === FileUploadStatus.ERROR
      ) {
        statusIcon = <ErrorIcon icon={closeOutline} />;
      }
    }

    return (
      <SelectedItem key={index} lines="full">
        {statusIcon}
        <FileInfo>
          <FileName>{file.name}</FileName>
          <FileSize>{prettyBytes(file.size)}</FileSize>
          {progressBar}
        </FileInfo>
        {cancelButton}
      </SelectedItem>
    );
  });

  const selectedComponent = (
    <SelectedContainer>{selectedItems}</SelectedContainer>
  );

  return (
    <>
      {selectedFiles.length > 0 ? selectedComponent : dropZoneComponent}
      <SubmitButton
        disabled={submitButtonDisabled || selectedFiles.length === 0}
        onClick={() => {
          setSubmitButtonDisabled(true);
          props.onSubmit(selectedFiles);
        }}
      >
        {props.submitButtonText}
      </SubmitButton>
    </>
  );
};

export default FileSelector;
